import { render } from "./PaymentReceiptCreatePaymentInfoCard.vue?vue&type=template&id=beb751b4&scoped=true"
import script from "./PaymentReceiptCreatePaymentInfoCard.vue?vue&type=script&lang=js"
export * from "./PaymentReceiptCreatePaymentInfoCard.vue?vue&type=script&lang=js"

import "./PaymentReceiptCreatePaymentInfoCard.vue?vue&type=style&index=0&id=beb751b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-beb751b4"]])

export default __exports__